<template>
  <div class="AssociateTechniquesDetails margin-left-3Perc margin-Top-3Perc margin-right-1Point3Perc">
    <div class="text-align-left text-color-red margin-bottom-1Perc">
      Note: Techniques should be associated before the course begins or if they have never associated before.
    </div>
    <div class="font-weight-bold text-align-left" v-if="!showParsedTechniqueResp">
      Feedback Questions
    </div>
    <div class="row text-align-left" v-if="!showParsedTechniqueResp">
      <div v-html="getparseTechniqueResponse" class="col-md-12 col-lg-12">
      </div>  
    </div>
    <div class="row text-align-left" v-if="showParsedTechniqueResp">
      <div v-html="getAssociatedTechniques" class="col-md-12 col-lg-12">
      </div>  
    </div>
    <div class="row text-align-left">
      <div v-html="getParsedTechniqueString" class="col-md-12 col-lg-12">
      </div>  
    </div>
  </div>  
</template>

<script>
export default {
  props: ['challengeObj', 'parseTechniqueResponse', 'showParsedTechniqueResp'],
  created: function () {},
  data: function () {
    return {
      parsedTechniquesArr: [],
      parsedTechiques: ''
    }
  },
  computed: {
    getAssociatedTechniques: {
      get: function () {
        var strToReturn = ''
        strToReturn = this.challengeObj.TrafficLightQuestions.replace(/\n/g, '<br/>')
        return strToReturn
      }
    },
    getParsedTechniques: {
      get: function () {
        if (this.challengeObj !== null && (!this.showParsedTechniqueResp)) {
          // AK: get all technique names prsent in between string
          return this.challengeObj.TrafficLightQuestions.match(/<b>(.*?)<\/b>/g)
        }
        return this.challengeObj.TrafficLightQuestions
      }
    },
    getParsedTechniqueString: {
      get: function () {
        var strToReturn = ''
        if (this.getparseTechniqueResponse.length === 0) {
          strToReturn = '<br/><b>Techniques not parsed.<b>'
        } else {
          for (var i = 0; i < this.getparseTechniqueResponse.length; i++) {
            if (i === 0) {
              strToReturn += '<br/><b>All Parsed Techniques:</b> <br/>'
              strToReturn += this.parseTechniqueResponse[i] + '<br/>'
            } else {
              strToReturn += this.parseTechniqueResponse[i] + '<br/>'
            }
          }
        }
        return strToReturn
      }
    },
    getparseTechniqueResponse: {
      get: function () {
        console.log('this.parseTechniqueResponse.Output ' + JSON.stringify(this.parseTechniqueResponse))
        return this.parseTechniqueResponse
      }
    }
  },
  name: 'AssociateTechniquesDetails'
}
</script>

<style scoped>
h4 { font-weight:normal; }
.font-weight-bold {
  font-weight: bold;
}
.AssociateTechniquesDetails {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.text-align-left{
  text-align:left;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-Top-3Perc{
  margin-Top:3%;
}
.margin-right-1Point3Perc{
  margin-right:1.3% !important;
}
.text-color-red {
  /* color: #800000; */
  color: darkred;
}
.margin-bottom-1Perc {
  margin-bottom: 1% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AssociateTechniquesDetails.vue